import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { collection, onSnapshot, getDocs, getDoc, doc, updateDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from "../firebase";
import QRCode from 'react-qr-code';
import DateTimePicker from "react-datetime-picker";
import { useNavigate } from 'react-router-dom';

const AdminPanel = () => {
    const [orders, setOrders] = useState([]);
    const [search, setSearch] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [adminData, setAdminData] = useState(null);
    const auth = getAuth();
    const [showQRModal, setShowQRModal] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState('');
    const [showPhotosModal, setShowPhotosModal] = useState(false);
    const [selectedPhotos, setSelectedPhotos] = useState([]);
    const [showNewOrderModal, setShowNewOrderModal] = useState(false);
    const navigate = useNavigate();

    // форма
    const [fullName, setFullName] = useState('');
    const [documentType, setDocumentType] = useState('Passport');
    const [documentNumber, setDocumentNumber] = useState('');
    const [nationality, setNationality] = useState('Argentina');
    const [phone, setPhone] = useState('');
    const [phoneCode, setPhoneCode] = useState('+54');
    const [email, setEmail] = useState('');
    const [emailTouched, setEmailTouched] = useState(false);
        const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    const emailIsValid = isValidEmail(email);
    const increaseBags = () => {
        setBags((prev) => prev + 1);
    };
    const decreaseBags = () => {
        if (bags > 1) {
            setBags((prev) => prev - 1);
        }
    };
    const [bags, setBags] = useState(1);
    const [checkIn, setCheckIn] = useState(new Date());
    const [checkOut, setCheckOut] = useState(() => {
        const date = new Date(Date.now() + 1000 * 60 * 60 * 4);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    });
    const canSubmit =
        fullName.trim().length > 0 &&
        documentNumber.trim().length > 0 &&
        emailIsValid;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [orderId, setOrderId] = useState('');
    function genCode() {
        const d = new Date();
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const r = Math.floor(Math.random() * 9000) + 1000;
        return `KFF-${dd}${mm}-${r}`;
    }
    const [orderSubmitted, setOrderSubmitted] = useState(false);

const handleSubmit = async () => {
    if (!canSubmit || isSubmitting) return;
    try {
        setIsSubmitting(true);
        const newOrderId = genCode();
        // 1. CAPTCHA CHECK (Worker)
        const recaptchaToken = await getRecaptchaToken();
        const res = await fetch(
            'https://koffer-email.kofferbagss.workers.dev',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    recaptchaToken,
                    email,
                    fullName,
                    orderId: newOrderId,
                    bags,
                    checkIn: checkIn.toLocaleString(),
                    checkOut: checkOut.toLocaleString(),
                }),
            }
        );
        const data = await res.json();
        // console.log("WORKER RESPONSE:", data); // 👈 ВОТ ЭТО ДОБАВЬ
        // ❌ если бот
        if (data.error) {
            throw new Error(data.error);
        }
        // 2. создаём ID
        setOrderId(newOrderId);
        const orderData = {
            orderId: newOrderId,
            status: "Pending",
            fullName,
            documentType,
            documentNumber,
            nationality,
            phoneCode,
            phone,
            email,
            bags,
            checkIn,
            checkOut,
            createdAt: serverTimestamp(),
        };
        // 3. EMAIL
        await fetch(
            'https://koffer-email.kofferbagss.workers.dev',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...orderData,
                    checkIn: checkIn.toLocaleString(),
                    checkOut: checkOut.toLocaleString(),
                }),
            }
        );
        // 4. FIRESTORE
        await setDoc(doc(db, "Orders", newOrderId), orderData);
        setOrderSubmitted(true);
        // Очистка формы
    setFullName('');
    setDocumentType('Passport');
    setDocumentNumber('');
    setNationality('Argentina');
    setPhone('');
    setPhoneCode('+54');
    setEmail('');
    setBags(1);
    setCheckIn(new Date());
    const defaultCheckOut = new Date(Date.now() + 1000 * 60 * 60 * 4);
    defaultCheckOut.setMinutes(0);
    defaultCheckOut.setSeconds(0);
    defaultCheckOut.setMilliseconds(0);
    setCheckOut(defaultCheckOut);
    setOrderSubmitted(false);
    setEmailTouched(false);
    setIsSubmitting(false);
    } catch (error) {
        console.error(error);
        setIsSubmitting(false);
    }
};

    const getRecaptchaToken = async () => {
    return new Promise((resolve) => {
        window.grecaptcha.ready(async () => {
        const token = await window.grecaptcha.execute(
            "6LeKxO0sAAAAAARlBwI2V6jyNnsr4ihq0TPBd0tY",
            { action: "submit" }
        );
        resolve(token);
        });
    });
    };

    const countryCodes = [
        { country: 'Afghanistan', code: '+93', flag: '🇦🇫' },
        { country: 'Albania', code: '+355', flag: '🇦🇱' },
        { country: 'Algeria', code: '+213', flag: '🇩🇿' },
        { country: 'Andorra', code: '+376', flag: '🇦🇩' },
        { country: 'Angola', code: '+244', flag: '🇦🇴' },
        { country: 'Antigua and Barbuda', code: '+1-268', flag: '🇦🇬' },
        { country: 'Argentina', code: '+54', flag: '🇦🇷' },
        { country: 'Armenia', code: '+374', flag: '🇦🇲' },
        { country: 'Australia', code: '+61', flag: '🇦🇺' },
        { country: 'Austria', code: '+43', flag: '🇦🇹' },
        { country: 'Azerbaijan', code: '+994', flag: '🇦🇿' },
        { country: 'Bahamas', code: '+1-242', flag: '🇧🇸' },
        { country: 'Bahrain', code: '+973', flag: '🇧🇭' },
        { country: 'Bangladesh', code: '+880', flag: '🇧🇩' },
        { country: 'Barbados', code: '+1-246', flag: '🇧🇧' },
        { country: 'Belarus', code: '+375', flag: '🇧🇾' },
        { country: 'Belgium', code: '+32', flag: '🇧🇪' },
        { country: 'Belize', code: '+501', flag: '🇧🇿' },
        { country: 'Benin', code: '+229', flag: '🇧🇯' },
        { country: 'Bhutan', code: '+975', flag: '🇧🇹' },
        { country: 'Bolivia', code: '+591', flag: '🇧🇴' },
        { country: 'Bosnia and Herzegovina', code: '+387', flag: '🇧🇦' },
        { country: 'Botswana', code: '+267', flag: '🇧🇼' },
        { country: 'Brasil', code: '+55', flag: '🇧🇷' },
        { country: 'Brunei', code: '+673', flag: '🇧🇳' },
        { country: 'Bulgaria', code: '+359', flag: '🇧🇬' },
        { country: 'Burkina Faso', code: '+226', flag: '🇧🇫' },
        { country: 'Burundi', code: '+257', flag: '🇧🇮' },
        { country: 'Cambodia', code: '+855', flag: '🇰🇭' },
        { country: 'Cameroon', code: '+237', flag: '🇨🇲' },
        { country: 'Canada', code: '+1', flag: '🇨🇦' },
        { country: 'Chile', code: '+56', flag: '🇨🇱' },
        { country: 'China', code: '+86', flag: '🇨🇳' },
        { country: 'Colombia', code: '+57', flag: '🇨🇴' },
        { country: 'Costa Rica', code: '+506', flag: '🇨🇷' },
        { country: 'Croatia', code: '+385', flag: '🇭🇷' },
        { country: 'Cuba', code: '+53', flag: '🇨🇺' },
        { country: 'Cyprus', code: '+357', flag: '🇨🇾' },
        { country: 'Czech Republic', code: '+420', flag: '🇨🇿' },
        { country: 'Denmark', code: '+45', flag: '🇩🇰' },
        { country: 'Dominican Republic', code: '+1-809', flag: '🇩🇴' },
        { country: 'Ecuador', code: '+593', flag: '🇪🇨' },
        { country: 'Egypt', code: '+20', flag: '🇪🇬' },
        { country: 'El Salvador', code: '+503', flag: '🇸🇻' },
        { country: 'Estonia', code: '+372', flag: '🇪🇪' },
        { country: 'Ethiopia', code: '+251', flag: '🇪🇹' },
        { country: 'Finland', code: '+358', flag: '🇫🇮' },
        { country: 'France', code: '+33', flag: '🇫🇷' },
        { country: 'Georgia', code: '+995', flag: '🇬🇪' },
        { country: 'Germany', code: '+49', flag: '🇩🇪' },
        { country: 'Ghana', code: '+233', flag: '🇬🇭' },
        { country: 'Greece', code: '+30', flag: '🇬🇷' },
        { country: 'Guatemala', code: '+502', flag: '🇬🇹' },
        { country: 'Haiti', code: '+509', flag: '🇭🇹' },
        { country: 'Honduras', code: '+504', flag: '🇭🇳' },
        { country: 'Hungary', code: '+36', flag: '🇭🇺' },
        { country: 'Iceland', code: '+354', flag: '🇮🇸' },
        { country: 'India', code: '+91', flag: '🇮🇳' },
        { country: 'Indonesia', code: '+62', flag: '🇮🇩' },
        { country: 'Iran', code: '+98', flag: '🇮🇷' },
        { country: 'Iraq', code: '+964', flag: '🇮🇶' },
        { country: 'Ireland', code: '+353', flag: '🇮🇪' },
        { country: 'Israel', code: '+972', flag: '🇮🇱' },
        { country: 'Italy', code: '+39', flag: '🇮🇹' },
        { country: 'Jamaica', code: '+1-876', flag: '🇯🇲' },
        { country: 'Japan', code: '+81', flag: '🇯🇵' },
        { country: 'Jordan', code: '+962', flag: '🇯🇴' },
        { country: 'Kazakhstan', code: '+7', flag: '🇰🇿' },
        { country: 'Kenya', code: '+254', flag: '🇰🇪' },
        { country: 'Kuwait', code: '+965', flag: '🇰🇼' },
        { country: 'Kyrgyzstan', code: '+996', flag: '🇰🇬' },
        { country: 'Laos', code: '+856', flag: '🇱🇦' },
        { country: 'Latvia', code: '+371', flag: '🇱🇻' },
        { country: 'Lebanon', code: '+961', flag: '🇱🇧' },
        { country: 'Libya', code: '+218', flag: '🇱🇾' },
        { country: 'Lithuania', code: '+370', flag: '🇱🇹' },
        { country: 'Luxembourg', code: '+352', flag: '🇱🇺' },
        { country: 'Malaysia', code: '+60', flag: '🇲🇾' },
        { country: 'Mexico', code: '+52', flag: '🇲🇽' },
        { country: 'Moldova', code: '+373', flag: '🇲🇩' },
        { country: 'Monaco', code: '+377', flag: '🇲🇨' },
        { country: 'Mongolia', code: '+976', flag: '🇲🇳' },
        { country: 'Morocco', code: '+212', flag: '🇲🇦' },
        { country: 'Nepal', code: '+977', flag: '🇳🇵' },
        { country: 'Netherlands', code: '+31', flag: '🇳🇱' },
        { country: 'New Zealand', code: '+64', flag: '🇳🇿' },
        { country: 'Nicaragua', code: '+505', flag: '🇳🇮' },
        { country: 'Nigeria', code: '+234', flag: '🇳🇬' },
        { country: 'North Korea', code: '+850', flag: '🇰🇵' },
        { country: 'Norway', code: '+47', flag: '🇳🇴' },
        { country: 'Pakistan', code: '+92', flag: '🇵🇰' },
        { country: 'Panama', code: '+507', flag: '🇵🇦' },
        { country: 'Paraguay', code: '+595', flag: '🇵🇾' },
        { country: 'Peru', code: '+51', flag: '🇵🇪' },
        { country: 'Philippines', code: '+63', flag: '🇵🇭' },
        { country: 'Poland', code: '+48', flag: '🇵🇱' },
        { country: 'Portugal', code: '+351', flag: '🇵🇹' },
        { country: 'Qatar', code: '+974', flag: '🇶🇦' },
        { country: 'Romania', code: '+40', flag: '🇷🇴' },
        { country: 'Russia', code: '+7', flag: '🇷🇺' },
        { country: 'Saudi Arabia', code: '+966', flag: '🇸🇦' },
        { country: 'Serbia', code: '+381', flag: '🇷🇸' },
        { country: 'Singapore', code: '+65', flag: '🇸🇬' },
        { country: 'Slovakia', code: '+421', flag: '🇸🇰' },
        { country: 'Slovenia', code: '+386', flag: '🇸🇮' },
        { country: 'South Africa', code: '+27', flag: '🇿🇦' },
        { country: 'South Korea', code: '+82', flag: '🇰🇷' },
        { country: 'Spain', code: '+34', flag: '🇪🇸' },
        { country: 'Sri Lanka', code: '+94', flag: '🇱🇰' },
        { country: 'Sweden', code: '+46', flag: '🇸🇪' },
        { country: 'Switzerland', code: '+41', flag: '🇨🇭' },
        { country: 'Syria', code: '+963', flag: '🇸🇾' },
        { country: 'Taiwan', code: '+886', flag: '🇹🇼' },
        { country: 'Thailand', code: '+66', flag: '🇹🇭' },
        { country: 'Tunisia', code: '+216', flag: '🇹🇳' },
        { country: 'Turkey', code: '+90', flag: '🇹🇷' },
        { country: 'Ukraine', code: '+380', flag: '🇺🇦' },
        { country: 'United Arab Emirates', code: '+971', flag: '🇦🇪' },
        { country: 'United Kingdom', code: '+44', flag: '🇬🇧' },
        { country: 'United States', code: '+1', flag: '🇺🇸' },
        { country: 'Uruguay', code: '+598', flag: '🇺🇾' },
        { country: 'Uzbekistan', code: '+998', flag: '🇺🇿' },
        { country: 'Venezuela', code: '+58', flag: '🇻🇪' },
        { country: 'Vietnam', code: '+84', flag: '🇻🇳' },
        { country: 'Yemen', code: '+967', flag: '🇾🇪' },
        { country: 'Zimbabwe', code: '+263', flag: '🇿🇼' },
    ];

    useEffect(() => {
      const auth = getAuth();
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
          console.log('USER UID:', user.uid);
          const docRef = doc(db, 'Admins', user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setAdminData(docSnap.data());
            console.log(docSnap.data());
          } else {
            console.log('Admin document not found');
          }
        }
      });
      return () => unsubscribe();
    }, []);

    useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, 'Orders'),
      (snapshot) => {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setOrders(data);
      }
    );
    return () => unsubscribe();
  }, []);

  const filteredOrders = orders.filter((order) => {
    const searchLower = search.toLowerCase();

    const matchesSearch =
      order.fullName?.toLowerCase().includes(searchLower) ||
      order.documentNumber?.toLowerCase().includes(searchLower) ||
      order.orderId?.toLowerCase().includes(searchLower);

    const today = new Date();

    const checkOutDate = order.checkOut?.toDate();

    const isToday =
    checkOutDate &&
    checkOutDate.getDate() === today.getDate() &&
    checkOutDate.getMonth() === today.getMonth() &&
    checkOutDate.getFullYear() === today.getFullYear();

  // ПРОСРОЧЕННЫЙ ЗАКАЗ
    const isExpired =
      checkOutDate &&
      checkOutDate < today &&
      order.status === 'Active';

    const matchesStatus =
    (statusFilter === 'all' && order.status !== 'Canceled') ||
    order.status === statusFilter ||
    (
      statusFilter === 'today' &&
      isToday &&
      order.status !== 'Canceled' &&
      order.status !== 'Finished'
    ) ||
    (
      statusFilter === 'expired' &&
      isExpired
    );

    return matchesSearch && matchesStatus;
  });

    const loadOrders = async () => {
    const snapshot = await getDocs(collection(db, 'Orders'));
    const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
    }));
    setOrders(data);
    };

    useEffect(() => {
    loadOrders();
    }, []);

    const cancelOrder = async (orderId) => {
      try {
        await updateDoc(doc(db, 'Orders', orderId), {
          status: 'Canceled',
          whoCanceled: adminData?.id,
        });
        console.log('Pedido cancelado');
      } catch (error) {
        console.error(error);
      }
    };

    const finishOrder = async (orderId) => {
      try {
        await updateDoc(doc(db, 'Orders', orderId), {
          status: 'Finished',
          whoFinished: adminData?.id
        });
        console.log('Pedido finalizado');
      } catch (error) {
        console.error(error);
      }
    };

    const statusTranslations = {
      Active: 'Activo',
      Pending: 'Pendiente',
      Finished: 'Retirado',
      Canceled: 'Borrado',
    };

    const addSeals = async (order) => {
      try {
        const seals = prompt('Ingrese los precintos separados por coma');
        if (!seals) return;
        const sealsArray = seals
          .split(',')
          .map((seal) => seal.trim())
          .filter((seal) => seal !== '');
        await updateDoc(doc(db, 'Orders', order.id), {
          seals: sealsArray,
          whoSealed: adminData?.id,
        });
        // EMAIL
        await fetch(
            'https://koffer-email.kofferbagss.workers.dev',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...order,
                    seals: sealsArray,
                    sendEmail: true,
                    checkIn: order.checkIn.toDate().toLocaleString(),
                    checkOut: order.checkOut.toDate().toLocaleString(),
                }),
            }
        );
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
        const selectedCountry = countryCodes.find(
            (item) => item.country === nationality
        );

        if (selectedCountry) {
            setPhoneCode(selectedCountry.code);
        }
    }, [nationality]);

  const isWindows = navigator.userAgent.includes('Windows');

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/');
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex min-h-screen bg-[#ded8cf] text-[#4b4037]">
      {/* Sidebar */}
      <aside className="flex w-[230px] flex-col border-r border-[#cfc6bb] bg-[#e5dfd7]">
        {/* Logo */}
        <div className="flex items-center gap-3 border-b border-[#d3cbc0] px-4 py-4">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl text-2xl text-white shadow-md">
            <img src='suitcase_Koffer_logo.png' />
          </div>

          <div>
            <div className="text-3xl font-extrabold leading-none text-[#221d19]">
              Koffer
            </div>

            <div className="mt-1 text-[11px] font-semibold uppercase tracking-[2px] text-[#9b8f83]">
              Drop Bags & Explore
            </div>
          </div>
        </div>

        {/* Menu */}
        <div className="px-3 py-6">
          <div className="mb-4 px-2 text-xs font-bold uppercase tracking-[2px] text-[#9d8f82]">
            Registros
          </div>

          <div className="space-y-0">
            <button onClick={() => setStatusFilter('all')} 
            // className="flex w-full items-center gap-3 rounded-2xl bg-white px-4 py-3 font-bold text-[#2f7d4f] shadow-sm"
            className={`flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-bold transition ${
              statusFilter === 'all'
                ? 'bg-white text-[#2f7d4f]'
                : ''
            }`}
            >
              <span className="text-xl">📋</span>
              Todos
            </button>

            <button onClick={() => setStatusFilter('Active')} 
            // className="flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-semibold transition hover:bg-white/70"
            className={`flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-bold transition ${
              statusFilter === 'Active'
                ? 'bg-white text-[#2f7d4f]'
                : ''
            }`}
            >
              <span className="text-xl">🟢</span>
              Activos
            </button>

            <button onClick={() => setStatusFilter('Pending')} 
            // className="flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-semibold transition hover:bg-white/70"
            className={`flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-bold transition ${
              statusFilter === 'Pending'
                ? 'bg-white text-[#2f7d4f]'
                : ''
            }`}
            >
              <span className="text-xl">⏳</span>
              Pendientes
            </button>

            <button onClick={() => setStatusFilter('expired')}
            // className="flex w-full items-center justify-between rounded-2xl px-4 py-3 font-semibold transition hover:bg-white/70"
            className={`flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-bold transition ${
              statusFilter === 'expired'
                ? 'bg-white text-[#2f7d4f]'
                : ''
            }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-xl">⚠️</span>
                Vencidos
              </div>
              {
                  orders.filter((order) => {
                    const today = new Date();
                    const checkOutDate = order.checkOut?.toDate();
                    return (
                      checkOutDate &&
                      checkOutDate < today &&
                      order.status === 'Active'
                    );
                  }).length > 0 && (
                    <div className="flex h-6 min-w-[24px] items-center justify-center rounded-full bg-red-700 px-2 text-xs font-bold text-white">
                      {
                        orders.filter((order) => {
                          const today = new Date();
                          const checkOutDate = order.checkOut?.toDate();
                          return (
                            checkOutDate &&
                            checkOutDate < today &&
                            order.status === 'Active'
                          );
                        }).length
                      }
                    </div>
                  )
                }
            </button>

            <button onClick={() => setStatusFilter('today')}
            // className="flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-semibold transition hover:bg-white/70"
            className={`flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-bold transition ${
              statusFilter === 'today'
                ? 'bg-white text-[#2f7d4f]'
                : ''
            }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-xl">📅</span>
                Para hoy
              </div>
              {
                orders.filter((order) => {
                  const today = new Date();
                  const checkOutDate = order.checkOut?.toDate();
                  const isToday =
                    checkOutDate &&
                    checkOutDate.getDate() === today.getDate() &&
                    checkOutDate.getMonth() === today.getMonth() &&
                    checkOutDate.getFullYear() === today.getFullYear();
                  return (
                    isToday &&
                    order.status !== 'Canceled' &&
                    order.status !== 'Finished'
                  );
                }).length > 0 && (
                  <div className="flex h-6 min-w-[24px] items-center justify-center rounded-full bg-green-700 px-2 text-xs font-bold text-white">
                    {
                      orders.filter((order) => {
                        const today = new Date();
                        const checkOutDate = order.checkOut?.toDate();
                        const isToday =
                          checkOutDate &&
                          checkOutDate.getDate() === today.getDate() &&
                          checkOutDate.getMonth() === today.getMonth() &&
                          checkOutDate.getFullYear() === today.getFullYear();
                        return (
                          isToday &&
                          order.status !== 'Canceled' &&
                          order.status !== 'Finished'
                        );
                      }).length
                    }
                  </div>
              )}

            </button>

            <button onClick={() => setStatusFilter('Finished')} 
            // className="flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-semibold transition hover:bg-white/70"
            className={`flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-bold transition ${
              statusFilter === 'Finished'
                ? 'bg-white text-[#2f7d4f]'
                : ''
            }`}
            >
              <span className="text-xl">✅</span>
              Retirados
            </button>

            <button onClick={() => setStatusFilter('Canceled')} 
            // className="flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-semibold transition hover:bg-white/70"
            className={`flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-bold transition ${
              statusFilter === 'Canceled'
                ? 'bg-white text-[#2f7d4f]'
                : ''
            }`}
            >
              <span className="text-xl">🗑️</span>
              Borrados
            </button>
          </div>

          <div className="mt-8 border-t border-[#cfc6bb] pt-6">
            <div className="mb-4 px-2 text-xs font-bold uppercase tracking-[2px] text-[#9d8f82]">
              Acciones
            </div>

            <div className="space-y-2">
              <button onClick={() => setShowNewOrderModal(true)} className="flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-semibold transition hover:bg-white/70">
                <span className="text-xl">➕</span>
                Nuevo ingreso
              </button>

              {/* <button className="flex w-full items-center gap-3 rounded-2xl px-4 py-3 font-semibold transition hover:bg-white/70">
                <span className="text-xl">⚙️</span>
                Configuración
              </button> */}
            </div>
          </div>
        </div>

        {/* Footer Stats */}
        {/* <div className="mt-auto border-t border-[#cfc6bb] px-4 py-5">
          <div className="flex justify-around text-center">
            <div>
              <div className="text-4xl font-extrabold text-[#2f8b57]">0</div>
              <div className="text-[10px] font-bold uppercase tracking-[2px] text-[#8d8075]">
                Activos
              </div>
            </div>

            <div>
              <div className="text-4xl font-extrabold text-[#c7392f]">1</div>
              <div className="text-[10px] font-bold uppercase tracking-[2px] text-[#8d8075]">
                Vencidos
              </div>
            </div>

            <div>
              <div className="text-4xl font-extrabold text-[#3b67d9]">0</div>
              <div className="text-[10px] font-bold uppercase tracking-[2px] text-[#8d8075]">
                Hoy
              </div>
            </div>
          </div>
        </div> */}
      </aside>

      {/* Main */}
      <main
        className="flex-1 bg-cover bg-center"
        style={{ backgroundImage: "url('/background.jpg')" }}
      >
        {/* Topbar */}
        <div className="flex items-center justify-between border-b border-[#d2c7bb] bg-[#ece6de]/95 px-6 py-3 backdrop-blur-md">
          <h1 className="text-3xl font-extrabold text-[#231f1b]">
            Todos los registros
          </h1>
<div className="flex items-center gap-4">
  <span className="text-lg font-light">
    Usuario:{' '}
    <span className="text-lg font-bold">
      {adminData?.name}
    </span>
  </span>
  <button
    onClick={handleLogout}
    className="
      flex
      items-center
      justify-center
      rounded-xl
      bg-red-400
      p-2
      text-black
      shadow-md
      transition
      hover:bg-red-600
      hover:text-white
      hover:scale-105
    "
    title="Cerrar sesión"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="h-5 w-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6A2.25 2.25 0 005.25 5.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m7-3l-4.5-4.5m4.5 4.5l-4.5 4.5m4.5-4.5H9"
      />
    </svg>
  </button>
</div>

          <div className="flex items-center gap-4">
            <button
            onClick={loadOrders}
            className="rounded-2xl border border-[#d3c7bb] bg-white px-6 py-3 font-bold shadow-sm hover:bg-[#f5f5f5]"
            >
            🔄 Actualizar
            </button>
            <div className="flex h-12 w-[300px] items-center rounded-2xl border border-[#cfc4b7] bg-white px-4 shadow-sm">
              <span className="mr-3 text-xl">🔍</span>

              <input
                type="text"
                placeholder="Nombre, DNI o código..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full bg-transparent outline-none"
              />
            </div>

            {/* <button className="rounded-2xl border border-[#d3c7bb] bg-white px-6 py-3 font-bold shadow-sm">
              ⬇ Exportar
            </button> */}

            <button onClick={() => setShowNewOrderModal(true)}
            className="rounded-2xl bg-[#22834d] px-6 py-3 font-bold text-white shadow-lg">
              + Nuevo ingreso
            </button>
          </div>
        </div>

        {/* Warning */}
        {/* <div className="border-b border-[#dccfc3] bg-[#f1d9d5]/70 px-6 py-3 text-lg font-bold text-[#b33d35] backdrop-blur-sm">
          • 1 valija vencida sin retirar
        </div> */}

        {/* Content */}
        <div className="p-2">
            <div className="mb-4 flex items-center justify-between">
                <div className="mb-1 text-xl font-bold text-[#56493f]">
                    Registros: {filteredOrders.length}
                </div>
                {/* Filters */}
                <div className="flex gap-3">
                    <button onClick={() => setStatusFilter('all')} 
                    className={`rounded-full px-5 py-2 font-semibold shadow-sm transition ${
                      statusFilter === 'all'
                        ? 'bg-[#22834d] text-white'
                        : 'bg-white'
                    }`}
                    >
                    Todos
                    </button>

                    <button onClick={() => setStatusFilter('Active')} 
                    className={`rounded-full px-5 py-2 font-semibold shadow-sm transition ${
                        statusFilter === 'Active'
                          ? 'bg-[#22834d] text-white'
                          : 'bg-white'
                      }`}
                    >
                    Activos
                    </button>

                    <button onClick={() => setStatusFilter('Pending')} 
                    className={`rounded-full px-5 py-2 font-semibold shadow-sm transition ${
                        statusFilter === 'Pending'
                          ? 'bg-[#22834d] text-white'
                          : 'bg-white'
                      }`}
                    >
                    Pendientes
                    </button>

                    <button onClick={() => setStatusFilter('expired')}
                    className={`rounded-full px-5 py-2 font-semibold shadow-sm transition ${
                        statusFilter === 'Expired'
                          ? 'bg-[#22834d] text-white'
                          : 'bg-white'
                      }`}
                    >
                    Vencidos
                    </button>

                    <button onClick={() => setStatusFilter('Finished')} 
                    className={`rounded-full px-5 py-2 font-semibold shadow-sm transition ${
                        statusFilter === 'Finished'
                          ? 'bg-[#22834d] text-white'
                          : 'bg-white'
                      }`}
                    >
                    Retirados
                    </button>
                </div>
            </div>

          {/* Table */}
          <div className="overflow-hidden rounded-2xl border border-[#e2d6ca] bg-white/50 shadow-lg backdrop-blur-sm">
            {/* Head */}
            <div className="grid grid-cols-9 gap-4 bg-[#f5efea] px-5 py-4 text-sm font-extrabold uppercase tracking-[1px] text-[#8e7d6e]">
              <div>Cliente</div>
              <div>Código</div>
              <div>Documento</div>
              <div>Valijas</div>
              <div>Ingreso / Retiro</div>
              <div>Precintos</div>
              <div>Estado</div>
              <div>Contactos</div>
              <div>Acción</div>
            </div>

            {/* Scrollable Rows */}
            <div className="max-h-[600px] overflow-y-auto">
              {filteredOrders.map((order) => (
                  <div
                    key={order.id}
                    className="grid grid-cols-9 gap-4 border-t border-[#e8ddd2] px-5 py-5 text-md text-[#3d342d]"
                  >
                    {/* Cliente */}
                    <div className="font-bold">
                      {order.fullName}
                    </div>
                    {/* Código */}
                    <div className="font-mono text-[#2f8b57]">
                      {order.orderId}
                    </div>
                    {/* Documento */}
                    <div>
                      {order.documentType} {order.documentNumber}
                    </div>
                    {/* Valijas */}
                    <div className="font-bold text-[#2d65db]">
                      {order.bags}
                    </div>
                    {/* Ingreso */}
                    <div>
                      <div className='text-green-700'>
                      Ingreso:<br />
                      {order.checkIn?.toDate().toLocaleString('es-AR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                      })}
                      </div>
                      <div className='text-blue-700'>
                        Retiro:<br />
                        {order.checkOut?.toDate().toLocaleString('es-AR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: false,
                        })}
                      </div>
                    </div>
                    {/* Precintos */}
                    <div>
                      {order.seals && order.seals.length > 0 ? (
                        <div className="flex flex-wrap gap-0.5">
                          {order.seals.map((seal, index) => (
                            <div
                              key={index}
                              className="rounded-lg bg-white px-3 py-0 font-bold text-[#2f7d4f]"
                            >
                              {seal}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <button
                          onClick={() => addSeals(order)}
                          className="rounded-lg bg-gray-400 px-3 py-2 text-white hover:bg-orange-600"
                        >
                          Agregar precintos
                        </button>
                      )}
                    </div>
                    {/* Estado */}
                    <div className="font-bold text-[#b63831]">
                      {statusTranslations[order.status] || order.status}
                    </div>
                    {/* Contactos */}
                    <div>
                      {order.phone && (
                      <div className="mt-1 text-sm text-[#6b7280]">
                          {order.phoneCode} {order.phone}
                      </div>
                      )}
                      <div className="mt-1 text-sm text-[#6b7280]">
                          {order.email}
                      </div>
                    </div>
                    {/* Acción */}
                    <div>
                      {order.status !== 'Canceled' && (
                        <>
                          {order.status === 'Pending' && (
                            <div>
                              <button
                                onClick={() => {
                                  setSelectedOrderId(order.id);
                                  setShowQRModal(true);
                                }}
                                className="font-bold text-md text-orange-600 hover:bg-white/70 hover:rounded-lg hover:shadow-lg"
                              >
                                <span className="text-xl">📷 </span>
                                Sacar fotos
                              </button>
                              <br />
                            </div>
                          )}
                          {order.status === 'Active' && (
                            <div>
                              {order.photos && order.photos.length > 0 && (
                                <button
                                  onClick={() => {
                                    setSelectedPhotos(order.photos);
                                    setShowPhotosModal(true);
                                  }}
                                  className="font-bold text-md text-blue-600 hover:bg-white/70 hover:rounded-lg hover:shadow-lg"
                                >
                                  <span className="text-xl">🖼️ </span>
                                  Mostrar fotos
                                </button>
                              )}
                            </div>
                          )}

                          {order.status !== 'Finished' && (
                            <>
                              <button
                                onClick={() => finishOrder(order.id)}
                                className="font-bold text-xl text-[#2f8b57] hover:bg-white/70 hover:rounded-lg hover:shadow-lg"
                              >
                                <span className="text-xl">☑️ </span>
                                Retirar
                              </button>

                              <br />
                              <br />
                            </>
                          )}
                          <button
                            onClick={() => cancelOrder(order.id)}
                            className="text-red-500 hover:bg-white/70 hover:rounded-lg hover:shadow-lg"
                          >
                            <span className="text-xl">🗑️ </span>
                            Borrar
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
                        {showQRModal && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
                    <div className="w-full max-w-[420px] rounded-2xl bg-white p-8 shadow-2xl">
                      <div className="text-center">
                        <h2 className="mb-4 text-2xl font-bold text-[#2f7d4f]">
                          Subir fotos
                        </h2>
                        <p className="mb-6 text-[#6b7280]">
                          Escaneá este QR con el teléfono
                        </p>
                        <div className="flex justify-center">
                          <div className="rounded-2xl bg-white p-4 shadow-lg">
                            <QRCode
                              value={`${window.location.origin}/upload/${selectedOrderId}`}
                              size={220}
                            />
                          </div>
                        </div>
                        <div className="mt-6 break-all text-sm text-[#6b7280]">
                          {window.location.origin}/upload/{selectedOrderId}
                        </div>
                        <button
                          onClick={() => setShowQRModal(false)}
                          className="mt-8 rounded-xl bg-[#2f7d4f] px-6 py-3 font-bold text-white"
                        >
                          Cerrar
                        </button>
                      </div>
                    </div>
                  </div>
                )}
{showPhotosModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
    <div className="max-h-[90vh] w-full max-w-[1000px] overflow-y-auto rounded-2xl bg-white p-6 shadow-2xl">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-2xl font-bold text-[#2f7d4f]">
          Fotos del pedido
        </h2>
        <button
          onClick={() => setShowPhotosModal(false)}
          className="rounded-xl bg-red-500 px-4 py-2 font-bold text-white"
        >
          Cerrar
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {selectedPhotos.map((photo, index) => (
          <img
            key={index}
            src={photo}
            alt=""
            className="w-full rounded-2xl border-4 border-[#4CAF50] object-cover shadow-lg"
          />
        ))}
      </div>
    </div>
  </div>
)}
{/* Modal */}

{showNewOrderModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
    {/* Background click */}
    <div
      className="absolute inset-0"
        onClick={() => {
          setShowNewOrderModal(false);
          // Очистка формы
          setFullName('');
          setDocumentType('Passport');
          setDocumentNumber('');
          setNationality('Argentina');
          setPhone('');
          setPhoneCode('+54');
          setEmail('');
          setBags(1);
          setCheckIn(new Date());
          const defaultCheckOut = new Date(Date.now() + 1000 * 60 * 60 * 4);
          defaultCheckOut.setMinutes(0);
          defaultCheckOut.setSeconds(0);
          defaultCheckOut.setMilliseconds(0);
          setCheckOut(defaultCheckOut);
          setIsSubmitting(false);
          setOrderSubmitted(false);
          setEmailTouched(false);
        }}
    />
    {/* Modal content */}
    <div
      className="relative max-h-[95vh] w-full max-w-6xl overflow-y-auto rounded-3xl bg-[#f7f3f0] p-6 shadow-2xl"
      style={{
        backgroundImage: "url('/background.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Close */}
      <button
        onClick={() => {
          setShowNewOrderModal(false);
          // Очистка формы
          setFullName('');
          setDocumentType('Passport');
          setDocumentNumber('');
          setNationality('Argentina');
          setPhone('');
          setPhoneCode('+54');
          setEmail('');
          setBags(1);
          setCheckIn(new Date());
          const defaultCheckOut = new Date(Date.now() + 1000 * 60 * 60 * 4);
          defaultCheckOut.setMinutes(0);
          defaultCheckOut.setSeconds(0);
          defaultCheckOut.setMilliseconds(0);
          setCheckOut(defaultCheckOut);
          setIsSubmitting(false);
          setOrderSubmitted(false);
          setEmailTouched(false);
        }}
        className="sticky top-0 ml-auto flex h-12 w-12 items-center justify-center rounded-full bg-white text-2xl font-bold text-[#6b5244] shadow-lg hover:bg-red-500 hover:text-white"
      >
        ✕
      </button>
      {/* FORM */}
      <div className="max-w-5xl mx-auto">
        {/* Nombre */}
        <div className="mb-6">
          <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
            Nombre Apellido *
          </label>
          <input
            type="text"
            placeholder="Ejemplo: John Smith"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className={`w-full bg-white border-2 rounded-2xl px-6 py-5 text-2xl outline-none focus:border-[#2e8b57] focus:ring-2 focus:ring-[#2e8b57]/20
            ${
              fullName.trim().length > 0
                ? 'border-green-600'
                : 'border-[#d8c8bc]'
            }`}
          />
        </div>
        {/* Documento */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
              Tipo de documento
            </label>
            <select
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
              className="w-full bg-white border border-[#d8c8bc] rounded-2xl px-6 py-5 text-2xl outline-none focus:border-[#2e8b57]"
            >
              <option>Passport</option>
              <option>DNI</option>
              <option>Other</option>
            </select>
          </div>
          <div>
            <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
              Número de documento *
            </label>
            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="12345678"
              value={documentNumber}
              onChange={(e) =>
                setDocumentNumber(
                  e.target.value.replace(/\D/g, '')
                )
              }
              className={`w-full bg-white border-2 rounded-2xl px-6 py-5 text-2xl outline-none focus:border-[#2e8b57]
              ${
                documentNumber.trim().length > 0
                  ? 'border-green-600'
                  : 'border-[#d8c8bc]'
              }`}
            />
          </div>
        </div>
        {/* Nacionalidad */}
        <div className="mb-6 max-w-md">
          <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
            Nacionalidad
          </label>
          <select
            value={nationality}
            onChange={(e) => setNationality(e.target.value)}
            className="w-full bg-white border-4 border-[#2e8b57] rounded-2xl px-6 py-5 text-2xl outline-none"
          >
            {countryCodes.map((item) => (
              <option
                key={item.country}
                value={item.country}
              >
              {
              isWindows
                  ? `${item.country}`
                  : `${item.flag} ${item.country}`
              }
              </option>
            ))}
          </select>
        </div>
        {/* Telefono */}
        <div className="mb-6">
          <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
            Número de teléfono
          </label>
          <div className="flex flex-col md:flex-row gap-4">
            <select
              value={phoneCode}
              onChange={(e) => setPhoneCode(e.target.value)}
              className="bg-[#ebe6e1] rounded-2xl px-6 py-5 text-2xl min-w-[220px] outline-none"
            >
              {countryCodes.map((item) => (
                <option key={item.country} value={item.code}>
                {
                  isWindows
                    ? `${item.code} (${item.country})`
                    : `${item.flag} ${item.code} (${item.country})`
                }
                </option>
              ))}
            </select>
            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="11 2345-6789"
              value={phone}
              onChange={(e) =>
                setPhone(
                  e.target.value.replace(/\D/g, '')
                )
              }
              className={`flex-1 bg-white border-2 rounded-2xl px-6 py-5 text-2xl outline-none focus:border-[#2e8b57]
              ${
                phone.trim().length > 0
                  ? 'border-green-600'
                  : 'border-[#d8c8bc]'
              }`}
            />
          </div>
        </div>
        {/* Email */}
        <div className="mb-10">
          <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
            Email *
          </label>
          <input
            type="email"
            placeholder="client@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={() => setEmailTouched(true)}
            className={`w-full bg-white border-2 rounded-2xl px-6 py-5 text-2xl outline-none transition-colors
            ${
              email.length === 0 && !emailTouched
                ? 'border-[#d8c8bc]'
                : emailIsValid
                ? 'border-green-600'
                : 'border-red-500'
            }`}
          />
          {emailTouched && email.length > 0 && !emailIsValid && (
            <p className="text-red-500 mt-2 text-sm">
              Incorrecto email formato
            </p>
          )}
        </div>
        {/* Cantidad */}
        <div className="mb-10">
          <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
            Cantidad de valijas
          </label>
          <div className="bg-white border border-[#d8c8bc] rounded-2xl w-[260px] px-8 py-5 flex items-center justify-between">
            <button
              onClick={decreaseBags}
              className="text-4xl font-bold text-[#2b1c18]"
            >
              −
            </button>
            <span className="text-4xl font-bold text-[#2e8b57]">
              {bags}
            </span>
            <button
              onClick={increaseBags}
              className="text-4xl font-bold text-[#2b1c18]"
            >
              +
            </button>
          </div>
        </div>
        {/* Fechas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Check-in */}
          <div>
            <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
              Ingreso
            </label>
            <div className="bg-white border border-[#d8c8bc] rounded-2xl px-6 py-5">
              <DateTimePicker
                onChange={setCheckIn}
                value={checkIn}
                disableClock={true}
                clearIcon={null}
                calendarIcon={null}
                format="dd.MM.yyyy, HH:mm"
                className="koffer-datepicker"
              />
            </div>
          </div>
          {/* Check-out */}
          <div>
            <label className="block text-[#6b5244] font-bold uppercase tracking-wide mb-3">
              Retiro
            </label>
            <div className="bg-white border border-[#d8c8bc] rounded-2xl px-6 py-5">
              <DateTimePicker
                onChange={setCheckOut}
                value={checkOut}
                minDate={checkIn}
                disableClock={true}
                clearIcon={null}
                calendarIcon={null}
                format="dd.MM.yyyy, HH:mm"
                className="koffer-datepicker"
              />
            </div>
          </div>
        </div>
        {/* Submit */}
        <div className="mt-10">
          <button
            onClick={async () => {
              await handleSubmit();
              setShowNewOrderModal(false);
            }}
            disabled={!canSubmit || isSubmitting || orderSubmitted}
            className={`
              w-full
              text-white
              font-bold
              text-2xl
              rounded-2xl
              py-6
              transition-all
              shadow-lg
              mt-10
              ${
                !canSubmit
                  ? 'bg-gray-400 cursor-not-allowed shadow-none'
                  : orderSubmitted || isSubmitting
                  ? 'bg-[#9aa09c] cursor-not-allowed shadow-none'
                  : 'bg-[#2e8b57] hover:bg-[#267349] active:scale-[0.99] shadow-[#2e8b57]/20'
              }
            `}
          >
            {
              orderSubmitted
                ? 'Completado'
                : isSubmitting
                ? 'Enviando...'
                : 'Finalizar'
            }
          </button>
        </div>
      </div>
    </div>
  </div>
)}
      </main>
    </div>
  );
}

export default AdminPanel;